import React from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import LockFilledIcon from '@atlaskit/icon/glyph/lock-filled';
import { token } from '@atlaskit/tokens';
import AKTooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { messages } from './messages';
import type { Props } from './types';

export const AppLinkOption = ({ value, onAuthenticateAppLink, selectType }: Props) => {
	const { formatMessage } = useIntl();

	const handleClick = (e: React.MouseEvent, analyticsEvent: UIAnalyticsEvent) => {
		e.preventDefault();
		if (onAuthenticateAppLink) {
			onAuthenticateAppLink(value.fullObject.authUrl, analyticsEvent);
			analyticsEvent &&
				fireUIAnalytics(analyticsEvent, selectType, {
					appLinkId: value.fullObject.id,
				});
		}
	};

	if (value.fullObject.requireCredentials) {
		return (
			<AKTooltip content={value.fullObject.baseUrl} position="bottom">
				<StyledAppLink>
					<span>{value.label}</span>
					<Button
						spacing="none"
						appearance="link"
						onClick={handleClick}
						iconBefore={<LockFilledIcon size="small" label="" />}
						interactionName="auto-generated.jira-issue-view-common-views.app-link.app-link-option.button"
					>
						<span>{formatMessage(messages.remoteLinkAuthText)}</span>
					</Button>
				</StyledAppLink>
			</AKTooltip>
		);
	}
	return (
		<AKTooltip content={value.fullObject.baseUrl} position="bottom">
			<StyledAppLink>{value.label}</StyledAppLink>
		</AKTooltip>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledAppLink = styled.p({
	display: 'flex',
	gap: token('space.150', '12px'),
});
